<template>
   <div class="flex flex-col gap-2">
      <div
         class="flex gap-2 overflow-x-auto py-1 [-webkit-overflow-scrolling:touch] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
         :class="{ 'px-4': bleed }"
      >
         <div v-for="(tab, index) in tabs" :key="index" class="shrink-0">
            <Button
               :disabled="disabled ? (Array.isArray(disabled) ? disabled[index] : disabled) : false"
               :variant="model !== index ? 'filter-inactive' : 'filter-active'"
               @click="model = index"
               :badge="typeof tab === 'string' ? undefined : tab.badge"
            >
               {{ typeof tab === 'string' ? tab : tab.title }}
            </Button>
         </div>
      </div>
      <slot :name="model.toString()" />
   </div>
</template>

<script lang="ts" setup>
export type Tabs = (string | { title: string; badge?: boolean })[]

type Props = {
   tabs: Tabs
   disabled?: boolean | boolean[]
   bleed?: boolean
}

const props = withDefaults(defineProps<Props>(), {})
const model = defineModel<number>({ default: 0 })
</script>
